import React, { useEffect, useState } from 'react';
import check2Icon from 'assets/icons/check2Icon.svg';
import unCheck2Icon from 'assets/icons/unCheck2Icon.svg';

const AppCheckBox = ({ label, checked, onChange, className, nameInput }) => {
    const [check, setCheck] = useState(checked || false);

    const handleChange = (e) => {
        setCheck(!check);
        onChange && onChange(e);
    }

    useEffect(() => {
        setCheck(checked);
    }, [checked]);

    return (
        <label className={`htCheckbox ${className}`} onClick={(e) => e.stopPropagation()}>
            {label}
            <input type="checkbox" checked={checked} name={nameInput}  onChange={(e)=> handleChange(e)} />
            {check ? <img src={check2Icon} alt="check" /> : <img src={unCheck2Icon} alt="uncheck" />}
        </label>
    );
}

export default AppCheckBox;